var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9954,
    cy: 12.9999,
    rx: 12.2308,
    ry: 12.2353,
    fill: "#ACA2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8364 4.54102C21.8364 4.54102 27.0946 21.0924 10.4338 24.946C10.4338 24.946 19.2361 27.0655 23.8203 18.6646C23.8395 18.6646 28.0577 11.1307 21.8364 4.54102Z",
    fill: "#7A6DEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0196 15.1065C14.0196 14.7403 14.2532 14.4042 14.6141 14.2509C16.3933 13.4933 17.5883 11.6241 17.5883 10.3525C17.5883 8.01752 15.5298 6.11719 13.0001 6.11719C10.4704 6.11719 8.41187 8.01752 8.41187 10.3525C8.41187 10.8721 8.86759 11.2938 9.43141 11.2938C9.99523 11.2938 10.4511 10.8721 10.4511 10.3525C10.4511 9.05566 11.5941 7.9996 13.0001 7.9996C14.4061 7.9996 15.5491 9.05566 15.5491 10.3525C15.5491 10.9276 14.7987 12.0994 13.7598 12.5408C12.6799 13.0011 11.9806 14.008 11.9806 15.1065V15.5291C11.9806 16.0485 12.4363 16.4702 13.0001 16.4702C13.5639 16.4702 14.0196 16.0485 14.0196 15.5291V15.1065ZM11.9806 19.294C11.9806 19.8136 12.4373 20.2351 13.0001 20.2351C13.563 20.2351 14.0197 19.8136 14.0197 19.294C14.0197 18.7744 13.563 18.3529 13.0001 18.3529C12.4373 18.3529 11.9806 18.7744 11.9806 19.294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question-mark-icon.bce2c254836050c362caf121e879b152.svg";
export { ForwardRef as ReactComponent };